import { render, staticRenderFns } from "./WordingEdit.vue?vue&type=template&id=60cf44fc&scoped=true&"
import script from "./WordingEdit.vue?vue&type=script&lang=js&"
export * from "./WordingEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60cf44fc",
  null
  
)

export default component.exports